export const SET_SHIFTS = "SET_SHIFTS";
export const SET_REPAIRS = "SET_REPAIRS";
export const SET_ANALYSES = "SET_ANALYSES";
